import { FC, useContext, useEffect, useState } from "react"
import { Flex } from "@capioweb/ui-components/src"
import {
	PageBaseProps,
	BreadcrumbItemProps,
} from "../../components/Core/pageBase"
import { BreadcrumbsBlock } from "../../components"
import { LoginSharedForm } from "./components"
import {
	LoginSharedFormContextProvider,
	LoginSharedFormContext,
} from "./context/LoginSharedFormContext"
import { SharedFormProps } from "../../@types/CapioWeb/core"
import { useLocation } from "react-router-dom"
import { useQueryClient } from "react-query"

interface CapioLoginPageProps extends PageBaseProps {
	breadcrumb: Array<BreadcrumbItemProps>
	loginForm: SharedFormProps
	forgotPasswordForm: SharedFormProps
}

const CapioLoginPage: FC<CapioLoginPageProps> = ({
	breadcrumb,
	loginForm,
	forgotPasswordForm,
}) => {
	const location = useLocation()
	const queryClient = useQueryClient()
	const [cacheCleared, clearCacheState] = useState(0)
	const path = location.pathname + location.search

	useEffect(() => {
		if (cacheCleared == 0) {
			clearCacheState(1)
			queryClient.invalidateQueries({ queryKey: [path] })
		}
	}, [])

	const { setActiveFormVariant } = useContext(LoginSharedFormContext)

	useEffect(() => {
		setActiveFormVariant("forgotPasswordForm")
	}, [setActiveFormVariant])

	return (
		<Flex display="block" w={1}>
			<BreadcrumbsBlock items={breadcrumb} />
			<Flex w={1} py={8} px={3} backgroundColor="greyEE">
				<LoginSharedFormContextProvider defaultFormVariant="loginForm">
					<LoginSharedForm
						forms={{
							loginForm,
							forgotPasswordForm,
						}}
					/>
				</LoginSharedFormContextProvider>
			</Flex>
		</Flex>
	)
}

export { CapioLoginPage }
